import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../../setup'
import { Dimensioner } from './types'

export const useFreightSnap = () => {
    const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as any

    const dimensioners: Dimensioner[] = Array.isArray(user?.dimensioners)
        ? user.dimensioners.map((d: any) => ({
            dimensionerId: d.id ?? d.dimensionerId,
            locationId: d.locationId,
            name: d.name,
            active: d.active,
            defaultPackageType: d.defaultPackageType,
        }))
        : []

    const enabled = user?.freightSnapEnabled === true || dimensioners.length > 0
    const defaultDimensionerId = user?.freightSnapDefaultDimensioner
    const locationId = user?.freightSnapLocationId ?? dimensioners[0]?.locationId

    return {enabled, defaultDimensionerId, locationId, dimensioners}
}
